import React, { useContext } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Link from 'next/link';

import Header from '@invideoio/web-shared/components/Header';
import { AppType } from '@invideoio/web-shared/constants/common';
import {
  AmplitudeEvents,
  sendAmplitudeAnalyticEvent,
  sendRudderStackAnalyticEvent,
} from '@utils/analytics';

import { AUTH_TYPE, HOMEPAGE_HERO_SECTION } from '@constants/homepage';
import { RedirectContext, StateContext } from '../../store/store';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { getAssetUrl } from '@utils/common.utils';
import { ClickCtaUxSource, ClickCtaType } from '../../types/analytics';
import StudioBanner from '@invideoio/web-shared/components/StudioBanner';
import HeaderConfig from '@invideoio/web-shared/constants/header';

const HeaderWithCTA = () => {
  const { handleClick } = useContext(RedirectContext);
  const globalState = useContext(StateContext);
  const { CTAUrl } = HOMEPAGE_HERO_SECTION;

  const { platform, os } = globalState;

  const host_url = process.env.NEXT_PUBLIC_BASE_HOST || 'https://invideo.io';

  const onLoginClick = () => {
    sendAmplitudeAnalyticEvent(AmplitudeEvents.clickLogin, {
      'Button Position': 'Top Right - Header',
    });
    sendRudderStackAnalyticEvent({
      event_name: 'click_cta',
      event_properties: {
        ux_source: ClickCtaUxSource.TopRightHeader,
        type: ClickCtaType.ClickLogin,
        feature_utm: 'na',
      },
    });
    handleClick(globalState.redirectionLink || CTAUrl, AUTH_TYPE.LOGIN);
  };

  const onSignupClick = () => {
    sendAmplitudeAnalyticEvent(AmplitudeEvents.clickSignUp, {
      btnPosition: 'Top Right - Header',
    });
    sendRudderStackAnalyticEvent({
      event_name: 'click_cta',
      event_properties: {
        ux_source: ClickCtaUxSource.TopRightHeader,
        type: ClickCtaType.ClickSignup,
        feature_utm: 'na',
      },
    });
    handleClick(globalState.redirectionLink || CTAUrl, AUTH_TYPE.SIGNUP);
  };

  return (
    <>
      <StudioBanner />
      <div className="iv-h-[56px]">
        <div
          className={ivclass(
            'iv-fixed',
            'iv-w-full',
            'iv-z-20',
            'iv-backdrop-blur-[30px]',
            'iv-bg-white-75',
          )}
        >
          <div className={ivclass('xl:iv-container xl:iv-mx-auto')}>
            <Header
              os={os}
              logoRedirectURL={host_url}
              menu={HeaderConfig.MENU_V2}
              platform={platform}
              onLogin={onLoginClick}
              onSignUp={onSignupClick}
              appType={AppType.Homepage}
              socialLinks={globalState.socialLinks}
              renderProps={() => (
                <Link href={'/blog/search'}>
                  <a
                    className={ivclass(
                      'sm:iv-mx-10 md:iv-mx-20 iv-mx-50 sm:iv-self-center',
                      'sm:iv-pt-2 md:iv-pt-[11px] lg:iv-pt-8 iv-pt-9',
                      'iv-opacity-75',
                    )}
                  >
                    <ImageComponent
                      elementype="native"
                      src={getAssetUrl('blog', '/icons/search-icon-header.svg')}
                      alt="search-icon"
                      height={16}
                      width={16}
                    />
                  </a>
                </Link>
              )}
              authFunctions={{
                onAILogin: onLoginClick,
                onAISignUp: onSignupClick,
                onStudioLogin: onLoginClick,
                onStudioSignUp: onSignupClick,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderWithCTA;
